module.exports = __webpack_public_path__ + "static/media/one-point-dice.58d8d872.svg";